(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-flipbook"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-tk-flipbook]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  let busy = false;
  let touchStart = null;
  let previousBodyOverflow = '';
  const activeFullscreen = () => document.fullscreenElement === root || root.matches(':fullscreen') || root.classList.contains('tk-flipbook--immersive');
  const syncFullscreenButton = () => {
    const button = root.querySelector('[data-tk-fullscreen]');
    if (!button) return;
    const active = activeFullscreen();
    button.setAttribute('aria-pressed', String(active));
    button.innerHTML = active ? '<span aria-hidden="true">⛶</span> Vollbild schließen (Esc)' : '<span aria-hidden="true">⛶</span> Vollbild öffnen';
  };
  const loadPage = async (href, pushState = true) => {
    if (busy) return;
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) {
      window.location.assign(url.href);
      return;
    }
    busy = true;
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.href, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Katalogseite konnte nicht geladen werden');
      const html = await response.text();
      const documentPage = new DOMParser().parseFromString(html, 'text/html');
      const nextInner = documentPage.querySelector('[data-tk-flipbook] .tk-flipbook__inner');
      const currentInner = root.querySelector('.tk-flipbook__inner');
      if (!nextInner || !currentInner) throw new Error('Katalogansicht fehlt');
      currentInner.replaceWith(nextInner);
      root.classList.add('tk-flipbook--immersive');
      document.body.style.overflow = 'hidden';
      if (pushState) window.history.pushState({ tkFlipbook: true }, '', url.href);
      document.title = documentPage.title || document.title;
      syncFullscreenButton();
    } catch (error) {
      window.location.assign(url.href);
    } finally {
      busy = false;
      root.removeAttribute('aria-busy');
    }
  };
  const toggleFullscreen = async () => {
    if (document.fullscreenElement === root) {
      await document.exitFullscreen();
      return;
    }
    if (root.classList.contains('tk-flipbook--immersive')) {
      root.classList.remove('tk-flipbook--immersive');
      document.body.style.overflow = previousBodyOverflow;
      syncFullscreenButton();
      return;
    }
    if (root.requestFullscreen) {
      try {
        await root.requestFullscreen();
        return;
      } catch (error) {}
    }
    previousBodyOverflow = document.body.style.overflow;
    root.classList.add('tk-flipbook--immersive');
    document.body.style.overflow = 'hidden';
    syncFullscreenButton();
  };
  document.addEventListener('fullscreenchange', syncFullscreenButton);
  root.addEventListener('click', event => {
    const fullscreen = event.target.closest('[data-tk-fullscreen]');
    if (fullscreen && root.contains(fullscreen)) {
      event.preventDefault();
      toggleFullscreen();
      return;
    }
    const link = event.target.closest('a');
    if (!link || !root.contains(link)) return;
    if (link.closest('.tk-flipbook__formats') || link.closest('.tk-flipbook__navigation')) {
      event.preventDefault();
      loadPage(link.href);
    }
  });
  root.addEventListener('submit', event => {
    const form = event.target.closest('.tk-flipbook__jump');
    if (!form) return;
    event.preventDefault();
    const url = new URL(form.action, window.location.href);
    new FormData(form).forEach((value, key) => url.searchParams.set(key, String(value)));
    loadPage(url.href);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && root.classList.contains('tk-flipbook--immersive') && document.fullscreenElement !== root) {
      root.classList.remove('tk-flipbook--immersive');
      document.body.style.overflow = previousBodyOverflow;
      syncFullscreenButton();
      return;
    }
    if (!activeFullscreen() || event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const direction = event.key === 'ArrowRight' ? 'next' : 'prev';
    const link = root.querySelector('.tk-flipbook__navigation a[rel="' + direction + '"]');
    if (!link) return;
    event.preventDefault();
    loadPage(link.href);
  });
  root.addEventListener('touchstart', event => {
    if (activeFullscreen() && event.changedTouches.length) touchStart = event.changedTouches[0].clientX;
  }, { passive: true });
  root.addEventListener('touchend', event => {
    if (!activeFullscreen() || touchStart === null || !event.changedTouches.length) return;
    const distance = event.changedTouches[0].clientX - touchStart;
    touchStart = null;
    if (Math.abs(distance) < 55) return;
    const direction = distance < 0 ? 'next' : 'prev';
    const link = root.querySelector('.tk-flipbook__navigation a[rel="' + direction + '"]');
    if (link) loadPage(link.href);
  }, { passive: true });
  window.addEventListener('popstate', () => loadPage(window.location.href, false));
  previousBodyOverflow = document.body.style.overflow;
  root.classList.add('tk-flipbook--immersive');
  document.body.style.overflow = 'hidden';
  syncFullscreenButton();
})();

  } catch(e) { console.error(e); }
})();
})();
